import { Button } from 'primereact/button';
import { useState, useEffect } from 'react';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import AddState from '../admin/AddState';
import '../../assests/css/common/responsive-ui.css';
import UserAddressService from '../../services/useraddress/useraddress.service';
import { PincodeAreaModel } from '../../models/cust-address/cust-address-model';
 
interface SearchPanelProps {
  reloadPage: (value: boolean) => void;
  setLoading: (loading: boolean) => void;
  setPageNumber: (pageNumber: number) => void;
  setPageSize: (pageSize: number) => void;
  setStateList: (states: PincodeAreaModel[]) => void;
  setTotalRecords: (total: number) => void;
  setSearchTerm: (searchTerm: any) => void;
  searchTerm: any;
}
 
const StateSearch: React.FC<SearchPanelProps> = ({
  reloadPage,
  setLoading,
  setPageNumber,
  setPageSize,
  setStateList,
  setTotalRecords,
  searchTerm, 
  setSearchTerm, 
 
}) => {
  const { t } = useTranslation();
  //const [selectedColumn, setSelectedColumn] = useState<string>('');  
  const [isAddArea, setAddArea] = useState(false);
  
  

  // const handleColumnChange = (e: DropdownChangeEvent) => {
  //   const selectedValue = e.value;
  //   setSelectedColumn(selectedValue);
  //   setPageNumber(1);
  //   setPageSize(10);
  //  fetchData(searchTerm, 1, 10);
  // };
 
  // const handleSearch = () => {
  //   setPageNumber(1);
  //   setPageSize(10);
  //   fetchData(searchTerm, 1, 10);
  // };
 
  const fetchData = async (searchTerm: any, pageNumber: number, pageSize: number) => {
    setLoading(true);
    try {
      const response = await UserAddressService.getAllStatesByfilter(searchTerm, pageNumber, pageSize);
      if (response) {
        setStateList(response.states);
        setTotalRecords(response.totalRecords);
        setSearchTerm(searchTerm);      
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setStateList([]);
    } finally {
      setLoading(false);
    }
  };

  const resetSearchFields = () => {
    setSearchTerm('');
    fetchData('',1,10);
  };

  const hideAddAreaModal = () => {
    setAddArea(!isAddArea);
    reloadPage(!isAddArea);
  };
 
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (typeof searchTerm === 'string' && searchTerm.trim().length >= 1) {
        setPageNumber(1);
        setPageSize(10);
        fetchData(searchTerm, 1, 10);
      }
    }, 500);
  
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);  
 
  return (
    <div className="col-12">
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem' }}>
        <div className="input-container font-bold text-white border-round" style={{ float: "left", width: "18%" }}>
          <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
              placeholder="Keyword Search"
              style={{ width: "100%" }}
            />
          </div>
        </div>
 
        <div className="buttons-container">
          <div className="filter-button font-bold text-white border-round ml-2" style={{ float: "left", textAlign: 'right', width: "10%" }}>
            <Button
              className="text-black border-round"
              style={{ width: "100%", textAlign: 'center' }}
              onClick={resetSearchFields}
              severity="success"
              
              raised
            >
              Reset
            </Button>
          </div>
          <div className="add-button-container border-round font-bold ml-3 text-primary" style={{ textAlign: 'right' }}>
            <Button
              className="bg-green-700 border-round p-button p-button-text p-component text-center text-white"
              style={{ textAlign: 'center' }}
              onClick={() => setAddArea(!isAddArea)}
              severity="secondary"
              text
              raised
            >
              Add
            </Button>
          </div>
        </div>
        {isAddArea && <AddState showAddUserModal={isAddArea} hideAddUserModal={hideAddAreaModal} />}
      </div>
    </div>
  );
};
 
export default StateSearch;